<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card class="dialog-wrapper">
      <loader
        v-if="isLoading"
        absolute
      />
      <v-card-title>
        <div class="dialog-header">
          <v-img class="fakt-logo" src="img/fakt-logo.png" />
          <v-img class="fakt-full-name" src="img/fakt-full-text.png" />
        </div>
      </v-card-title>
      <v-card-text style="padding-bottom: 0 !important;">
        <connection-agreement
          :organization="currentOrganization"
          :html="connectionAgreement"
        />
      </v-card-text>
      <v-card-actions class="dialog-actions">
        <div class="actions-wrapper">
          <div class="mb-3 mr-3">
            <v-checkbox
              v-model="acceptOfferAgreement"
              class="actions-checkbox"
              hide-details
              :rules="checkBoxRules"
              :ripple="false"
            >
              <template #label>
                <span>
                  Я принимаю условия
                  <span class="policy-link" @click="openOfferAgreement">
                    договора оферты
                  </span>
                </span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="acceptPersonalDataPolicy"
              class="actions-checkbox"
              hide-details
              :rules="checkBoxRules"
              :ripple="false"
            >
              <template #label>
                <span>
                  Я подтверждаю, что ознакомился с
                  <span class="policy-link" @click="openPersonalDataPolicy">
                    политикой конфиденциальности
                  </span>
                </span>
              </template>
            </v-checkbox>
          </div>
          <v-btn
            class="dialog-button mb-3"
            color="primary"
            :disabled="btnDisabled && false"
            :loading="isLoading"
            dark
            depressed
            large
            @click="acceptAgreement"
          >
            Я согласен, далее...
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Loader from '@/components/loader/Loader.vue'
  import permissions from '@/mixins/permissions'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import snackbarMessage from '@/mixins/snackbar-message'
  import ConnectionAgreement from './ConnectionAgreement.vue'
  import userOrganizationsApi from '@/api/user/organizations'
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'ConnectionAgreementDialog',
    components: { ConnectionAgreement, Loader },
    mixins: [permissions, snackbarMessage],
    data () {
      return {
        isLoading: false,
        connectionAgreement: null,
        acceptOfferAgreement: false,
        acceptPersonalDataPolicy: false,
        checkBoxRules: [(v) => !!v],
      }
    },
    computed: {
      ...mapState({
        showDialog: state => state.connectionAgreement.showDialog,
      }),
      ...mapGetters({
        currentOrganization: 'connectionAgreement/getCurrentOrganization',
      }),
      btnDisabled () {
        return !this.acceptOfferAgreement || !this.acceptPersonalDataPolicy
      },
    },
    watch: {
      '$route.query' () {
        this.showConnectionAgreement()
      },
      async currentOrganization (val) {
        if (val) {
          try {
            this.connectionAgreement = await userOrganizationsApi.fetchConnectionAgreement(val.id)
          } catch (e) {
            this.showErrorFromResponse(e)
          }
        }
      },
    },
    created () {
      this.showConnectionAgreement()
    },
    methods: {
      openPersonalDataPolicy () {
        window.open('https://fakt-crm.ru/privacy-policy', '_blank')
      },
      openOfferAgreement () {
        window.open('https://fakt-crm.ru/offer-agreement', '_blank')
      },
      showConnectionAgreement () {
        const orgId = this.$route.query['connection-agreement']

        if (orgId) {
          this.$store.dispatch('connectionAgreement/fetchOrganization', orgId)
        }
      },
      async acceptAgreement () {
        if (!this.acceptOfferAgreement || !this.acceptPersonalDataPolicy) {
          this.showErrorMessage('Необходимо согласиться с условиями договоров')
          return
        }

        if (!this.userCan(CRMPermission.AcceptConnectionAgreement)) {
          this.showErrorMessage('Доступ запрещен')
          return
        }

        this.isLoading = true
        try {
          await this.$store.dispatch('connectionAgreement/acceptConnectionAgreement')
          this.showSuccessMessage('Договор успешно подписан')
          this.acceptOfferAgreement = false
          this.acceptPersonalDataPolicy = false
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
::v-deep {
  .v-dialog {
    border-radius: 15px;
  }

  .theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #D9D9D9 !important;
  }

  .theme--dark.v-btn.v-btn--disabled {
    color: #0C0C0C !important;
  }

  .mdi-checkbox-blank-outline {
    color: #ff9100;
  }

  .v-input--checkbox .v-label {
    color: #0C0C0C;
  }
}

.dialog {
  &-wrapper {
    border-radius: 15px;
    background-color: #F1F3F6;
  }

  &-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 20px 10px 20px;
  }

  &-actions {
    padding: 25px 44px 10px 42px;
  }

  &-button {
    border-radius: 10px;
    padding: 0 36px !important;
    font-size: 18px;
    //height: 60px !important;
  }
}

.fakt-logo {
  max-width: 300px;
  max-height: 60px;
}

.fakt-full-name {
  max-width: 300px;
  max-height: 60px;
}

.policy-link {
  color: #FF9000;
  cursor: pointer;
}

.actions-wrapper {
  max-width: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
 // margin: 8px 25px 15px;

  .actions-checkbox {
    margin-top: 0;
    ::v-deep {
      .v-label {
        font-size: 14px;
      }
    }
  }

}

</style>
